import { ServerConfig } from "@/config/config";
import { Axios } from "@/utils/axios";

export enum LoyaltyTransactionType {
	EARN = 0,
	REDEEM = 1,
	MANUAL = 2
}

export interface ILoyaltyTransaction {
	ID:number;
	Points:number;
	Type:LoyaltyTransactionType;
	TimeCreated:Date;
	SaleID:number;
	BookYear:number;
	SaleNumber:string;
	SaleTypeName:string;
}

export class LoyaltyServiceClass {
	private readonly url = ServerConfig.host + "/loyalty";

	async getBalance(contactId:number):Promise<number> {
		let result = await Axios.get(`${this.url}/balance/${contactId}`);
		return result.data.Balance || 0;
	}

	async getTransactions(contactId:number):Promise<ILoyaltyTransaction[]> {
		let result = await Axios.get(`${this.url}/transactions/${contactId}`);
		return (result.data || []).map((t:any)=>{
			return {...t, TimeCreated: new Date(t.TimeCreated)} as ILoyaltyTransaction;
		});
	}

	async addManualPoints(contactId:number, points:number):Promise<void> {
		await Axios.post(`${this.url}/adjust`, {ContactID: contactId, Points: points});
	}
}

export const LoyaltyService = new LoyaltyServiceClass();
